// @internal
export function not(pred) {
  return function (...args) {
    return !pred(...args);
  };
}
